import { render, staticRenderFns } from "./InputSelectPlatformConfig.vue?vue&type=template&id=5184468c&scoped=true"
import script from "./InputSelectPlatformConfig.vue?vue&type=script&lang=js"
export * from "./InputSelectPlatformConfig.vue?vue&type=script&lang=js"
import style0 from "./InputSelectPlatformConfig.vue?vue&type=style&index=0&id=5184468c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5184468c",
  null
  
)

export default component.exports